import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Eye, Pencil, Edit, Edit2, Trash2 } from 'lucide-react';

interface TableActionsProps {
  /** View action - navigates to detail page */
  onView?: () => void;
  /** Edit action - opens edit dialog */
  onEdit?: () => void;
  /** Delete action - opens delete confirmation */
  onDelete?: () => void;
  /** Additional custom actions */
  additionalActions?: React.ReactNode;
  /** Which edit icon to use */
  editIcon?: 'pencil' | 'edit' | 'edit2';
}

/**
 * Zentrale, wiederverwendbare Komponente für Tabellen-Aktionen.
 * Verwendet einheitliche Icons, Größen und Abstände.
 */
export function TableActions({
  onView,
  onEdit,
  onDelete,
  additionalActions,
  editIcon = 'pencil',
}: TableActionsProps) {
  const { t } = useTranslation('common');
  const EditIcon = editIcon === 'pencil' ? Pencil : editIcon === 'edit' ? Edit : Edit2;

  return (
    <div className="flex items-center gap-1">
      {onView && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onView}
          title={t('actions.view')}
          className="p-1.5"
        >
          <Eye className="w-4 h-4" strokeWidth={2} />
        </Button>
      )}

      {onEdit && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onEdit}
          title={t('actions.edit')}
          className="p-1.5"
        >
          <EditIcon className="w-4 h-4" strokeWidth={2} />
        </Button>
      )}

      {additionalActions}

      {onDelete && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onDelete}
          title={t('actions.delete')}
          className="p-1.5"
        >
          <Trash2 className="w-4 h-4 text-red-600" strokeWidth={2} />
        </Button>
      )}
    </div>
  );
}
